import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function Portal({ children, rootId = 'portal-root' }) {
  const elRef = useRef(null);
  if (!elRef.current) {
    elRef.current = document.createElement('div');
  }

  useEffect(() => {
    let root = document.getElementById(rootId);
    if (!root) {
      root = document.createElement('div');
      root.id = rootId;
      root.className = 'fixed inset-0 z-50 bg-black/50 grid place-items-center';
      document.body.appendChild(root);
    }
    root.appendChild(elRef.current);
    return () => {
      root.removeChild(elRef.current);
      // Optional: remove root if empty
      if (root.childNodes.length === 0) {
        root.parentNode?.removeChild(root);
      }
    };
  }, [rootId]);

  return createPortal(children, elRef.current);
}